<template>
  <el-dialog
    class="radish-dia"
    title="新增职能模块"
    top="70px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form ref="form" :model="form" label-width="200px">
      <el-form-item label="名称"> <el-input v-model="form['名称']"></el-input> </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="form['类型']" placeholder="请选择" filterable>
          <el-option v-for="item in types" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="大职能板块"> <el-input v-model="form['大职能板块']"></el-input> </el-form-item>
      <el-form-item label="负责人">
        <el-select v-model="form['负责人']" multiple filterable placeholder="请选择">
          <el-option v-for="item in accounts" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="细分职能(输入并回车添加)">
        <el-select
          v-model="form['二级职能']"
          multiple
          filterable
          allow-create
          default-first-option
          placeholder="请选择"
        >
        </el-select>
      </el-form-item>
      <el-form-item label="擅长方向(输入并回车添加)">
        <el-select
          v-model="form['擅长方向']"
          multiple
          filterable
          allow-create
          default-first-option
          placeholder="请选择"
        >
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="saveCate">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data: function() {
    return {
      dialogVisible: false,
      form: {},
      accounts: [],
      types: [
        '通用-职能',
        '金融-职能',
        '咨询-职能',
        '互联网-职能',
        '消费-职能',
        '零售-职能',
        '新零售-职能',
        '医药器械-职能',
        '医疗大健康-职能',
        '交通贸易-职能',
        '广告-职能',
        '文化传媒-职能',
        '教育-职能',
        '机械制造-职能',
        '房地产-职能',
        '电子通讯-职能',
        '餐饮旅游-职能',
        '服务外包-职能',
        '农林牧渔-职能',
        '能源化工-职能',
        '政府/公共事业/非营利机构-职能',
        '其他-职能',
        '芯片-职能',
        '医疗-职能',
      ],
    }
  },
  mounted: function() {
    this.loadAccount()
  },
  methods: {
    open() {
      this.form = {}
      this.dialogVisible = true
    },
    loadAccount: async function() {
      const res = await app.service('misc').listAccounts()
      if (res.status == 'success') this.accounts = res.data.map(v => v.account)
    },
    saveCate: async function() {
      const dt = JSON.parse(JSON.stringify(this.form))
      const res = await app.service('misc').addCategory(dt)
      if (res.status == 'success') {
        this.$message.success(res.msg)
        const newCategory = Object.assign({}, { _id: res.data.id }, dt)
        this.$emit('addCategory', newCategory)
      }
      this.dialogVisible = false
    },
  },
}
</script>
